export const attachmentsFormatsSelector = (state: RootState) => state.uploadDocuments.attachmentsFormats;
